<template>
  <div style="height: 85vh; display: flex; flex-direction: column;">
    <div v-if="currentUser && !loading" style="flex: 1; overflow: hidden;">
      <div
        class="page-content"
        style="background: #fff !important; height: 100%;"
      >
        <div class="ibox" style="height: 100%;">
          <div class="ibox-body" style="height: 100%;">
            <div
              class="row justify-content-center no-gutters"
              style="height: 100%;"
            >
              <div
                class="col-sm-6 profile-block"
                style="border: 1px solid #F6EDEB;"
              >
              <div class="mr-2 p-1" style="height: 100%; overflow: hidden auto">
                  <Profile
                    :applicant-id="applicantId"
                    :fromContact="true"
                    :hide-header-right="false"
                    :hideMailIcon="true"
                    :isReviewer="isReviewer"
                    :isPreview="false"
                    :hideDownloadPdf="true"
                    :isMaxHeight="true"
                  />
                </div>
              </div>
              <div
                class="col-sm-6 p-3 message-block"
                style="height: 85vh; overflow-y: auto;background:#EBEFF1"
              >
                <div class="scout-section-container">
                  <ScoutJobSection />
                  <ScoutTypeSection />
                </div>
                <div
                  class="message-detail-container"
                  v-if="messagesByJobseeker.length > 0"
                >
                  <div
                      v-for="(item, index) in messagesByJobseeker"
                      :key="item._id"
                    >
                      <MessageDetailTable :message="item" />

                      <!-- Toggle button for every message -->
                      <div
                        class="toggle-details-button"
                        @click="toggleMessageDetails(item)"
                      >
                        <i
                          :class="
                            item.detailsVisible
                              ? 'fa fa-angle-double-up toggle-details-icon'
                              : 'fa fa-angle-double-down toggle-details-icon'
                          "
                        ></i>
                        <p class="toggle-details-text">詳細</p>
                      </div>

                      <MessageDetail
                        :message="item"
                        company="company"
                        v-if="item.detailsVisible"
                      />
                    </div>
                </div>

                <!-- <h3 class="p-2">スカウトする内容</h3> -->

                <div
                  class="message-button-container mt-1"
                  v-if="!openMessageComposeForm"
                >
                  <button class="btn message-button" @click="openMessageForm()">
                    再度連絡する
                  </button>
                </div>
                <MessageCompose
                  ref="messageComposeRef"
                  v-if="
                    messageByJobseeker.length == 0 ||
                      openMessageComposeForm == true ||
                      is_draft
                  "
                  :draftMessage="draftMessage"
                  :company="company"
                  :applicant="applicant"
                  :applicantJD="applicantJd"
                  :sentDate="sentDate"
                  :previewEmailBody="previewEmailBody"
                  :isSubmitting="isSubmitting"
                  :isFirstMessage="isFirstMessage"
                  @onSubmit="onSubmit"
                  @onDraft="onDraft"
                  @cancel="cancel"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from '../applicants/profile/Profile.vue';
import MessageCompose from './MessageCompose.vue';
import MessageDetailTable from './MessageDetailTable.vue';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import ApiService from '../../../service/apiService';
import Api from '../../../config/api';
import MessageDetail from './MessageDetail.vue';
import ScoutJobSection from './ScoutJobSection.vue';
import ScoutTypeSection from './ScoutTypeSection.vue';
import moment from 'moment';

export default {
  name: 'IndividualContact',
  props: ['applicant_id', 'showIndividualContact', 'applicantIndex', 'email'],
  components: {
    Profile,
    MessageCompose,
    MessageDetailTable,
    MessageDetail,
    ScoutJobSection,
    ScoutTypeSection,
  },
  data() {
    return {
      applicantId: this.applicant_id,
      applicantJd: null,
      previewEmailBody: '',
      fetchedApplicant: null,
      messageByJobseeker: [],
      openMessageComposeForm: true,
      showReplyForm: false,
      is_draft: false,
      draftMessage: {},
      isSubmitting: false,
      loading: false,
      selectedMessageId: null,
      index: this.applicantIndex,
      // applicant: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      applicantsCount: 'getApplicantCounts',
      currentPage: 'getPage',
      getFirstProfileModalOpen: 'getFirstProfileModalOpen',
      getLastProfileModalOpen: 'getLastProfileModalOpen',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      applicant: ({ applicant }) => applicant.profile,
      currentPageApplicants: ({ applicant }) => applicant.currentPageApplicants,
      currentApplicantJd: ({ applicant }) => applicant.applicantJD,
    }),
    rowNumber() {
      return this.index + 1 + (this.currentPage - 1) * 15;
    },
    company() {
      // console.log(this.currentUser);
      return this.currentUser.companyName;
    },
    hasIndividualContactAuthority() {
      return (
        this.currentUser &&
        this.currentUser.companyContactAuthority
      );
    },
    sentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Note that months are zero-based, so we add 1.
      const day = currentDate.getDate();
      const formattedDate = `${year}年${month}月${day}日`;
      return formattedDate;
    },
    isReviewer() {
      return this.currentUser.isCreateReviewUser;
    },
    // shouldShowSubmitButton() {
    //   const lastMessage = this.messagesByJobseeker[
    //     this.messagesByJobseeker.length - 1
    //   ];
    //   return (
    //     lastMessage &&
    //     this.selectedMessageId === lastMessage._id &&
    //     !this.openMessageComposeForm
    //   );
    // },
    // applicant: {
    //   get() {
    //     if (this.fetchedApplicant) {
    //       return this.fetchedApplicant;
    //     } else {
    //       return this.applicants.find(
    //         (seeker) => seeker.id === this.applicant_id
    //       );
    //     }
    //   },
    //   set(value) {
    //     this.fetchedApplicant = value;
    //   },
    // },
    messagesByJobseeker() {
      return this.messageByJobseeker.filter((msg) => {
        return msg.is_draft !== true;
      });
    },
    isFirstMessage() {
      return this.messageByJobseeker.length || 0;
    },
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
      setReloadApplicants: 'setReloadApplicants',
      removeApplicantFromTempList: 'removeApplicantFromTempList',
    }),
    ...mapActions(['addFlashMessages']),
    formatDate(date) {
      return date ? moment(date).format('YYYY/MM/DD') : '';
    },
    trimContent(content) {
      if (!content) return '';
      // First trim the entire content
      content = content.trim();
      // Then handle each line, preserving intentional line breaks
      const result = content
        .split('\n')
        .map((line) => {
          // Remove multiple spaces between words but keep single spaces
          return line.replace(/\s+/g, ' ').trim();
        })
        .join('\n');
      return result;
    },
    confirmMessage() {
      this.$refs.messageComposeRef.processMessage();
    },
    openMessageForm() {
      this.openMessageComposeForm = true;
    },
    hideModal() {
      this.$refs.scoutScreen.hide();
      if (this.currentPageApplicants.length !== this.applicants.length) {
        this.setReloadApplicants(true);
      }
    },
    async findMessageByJobseeker() {
      try {
        this.loading = true;
        let messageByJobseeker = await ApiService.get(
          Api.endpoints.MESSAGE_BY_JOBSEEKER(this.applicantId)
        );
        if (messageByJobseeker.data.length > 0)
          this.openMessageComposeForm = false;
        this.messageByJobseeker = messageByJobseeker.data;
        // add details visible property by using vue's set to make it reactive
        this.messageByJobseeker.forEach((message) => {
          this.$set(message, 'detailsVisible', false);
        });
        this.loading = false;
      } catch (err) {
        // console.log(err);
        this.parseErrorResponse(err.response);
        this.loading = false;
      }
    },
    findDraftMessage() {
      const draftMessage = this.messageByJobseeker.find(
        (msg) => msg.is_draft === true
      );
      // console.log(draftMessage);
      if (draftMessage) {
        this.openMessageComposeForm = true;
        this.is_draft = true;
        this.draftMessage = draftMessage;
      }
      // return draftMessage;
    },
    cancel() {
      this.openMessageComposeForm = false;
      // this.selectedMessageId = null;
    },
    async onSubmit({ data, reset, hide, draftId }) {
      try {
        this.isSubmitting = true;
        // console.log(this.isSubmitting);
        let method;
        let endpoint;
        if (draftId) {
          method = 'put';
          endpoint = Api.endpoints.SEND_DRAFT_MESSAGE_TO_JOBSEEKER(draftId);
        } else {
          method = 'post';
          endpoint = Api.endpoints.SEND_MESSAGE_TO_JOBSEEKER(this.applicantId);
        }
        let response = await ApiService[method](endpoint, data);
        // let response = await ApiService.post(Api.endpoints.SEND_MESSAGE_TO_JOBSEEKER(this.applicantId), data);
        if (response) {
          // this.addFlashMessages([
          //   { message: '個別連絡を送信しました', type: 'success' },
          // ]);
          let newMessage = response.data;
          newMessage.detailsVisible = false;
          let jobseekerMessages = this.messageByJobseeker;
          jobseekerMessages.push(newMessage);
          this.messageByJobseeker = jobseekerMessages;
          this.is_draft = false;
          this.draftMessage = {};
          this.openMessageComposeForm = false;
          reset();
          hide();
        }
        this.removeApplicantFromTempList(this.applicant);
        this.isSubmitting = false;
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.parseErrorResponse(err);
      }
    },
    async onDraft({ data, draftId }) {
      // e.preventDefault();
      try {
        this.isSubmitting = true;
        let method;
        let endpoint;
        if (draftId) {
          method = 'put';
          endpoint = Api.endpoints.EDIT_DRAFT_MESSAGE(draftId);
        } else {
          method = 'post';
          endpoint = Api.endpoints.DRAFT_MESSAGE(this.applicantId);
        }
        let response = await ApiService[method](endpoint, data);
        // console.log(response);
        if (response) {
          this.addFlashMessages([
            { message: '下書きを保存しました', type: 'success' },
          ]);
          let newMessage = response.data;
          // newMessage.detailsVisible = false;
          let jobseekerMessages = this.messageByJobseeker;
          jobseekerMessages.push(newMessage);
          this.messageByJobseeker = jobseekerMessages;
          this.draftMessage = newMessage;
          window.scrollTo(0, 0);
          // hide();
        }
        this.isSubmitting = false;
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
      }
    },
    isLatestMessage(item) {
      if (this.messagesByJobseeker.length === 0) return false;
      const lastItem = this.messagesByJobseeker[
        this.messagesByJobseeker.length - 1
      ];
      return item._id === lastItem._id;
    },
    toggleMessageDetails(item) {
      // Only allow toggling for the latest message
      // if (this.isLatestMessage(item)) {
        item.detailsVisible = !item.detailsVisible;
        this.selectedMessageId = item.detailsVisible ? item._id : null;
      // }
    },
    async loadApplicantData() {
      let applicantId = this.applicant_id
        ? this.applicant_id
        : this.$route.params.applicantId;
      this.applicantId = applicantId;
      await this.findMessageByJobseeker();
      this.findDraftMessage();
      try {
        let res = await ApiService.get(
          Api.endpoints.APPLICANT_PROFILE(this.applicantId)
        );
        const { applicant, applicantJd } = res.data.data;
        this.applicant = applicant;
        this.applicantJd = applicantJd;
      } catch (err) {
        if (err && err.response && err.response.status == 502) {
          this.addFlashMessages([
            {
              message: `${err.response.data.data.error_description}`,
              type: 'danger',
            },
          ]);
          this.loader = false;
          this.errors = [];
          this.parseErrorResponse(err.response);
          this.loader = false;
          window.scrollTo(0, 0);
        }
      }
    },
    changeApplicant(index) {
      this.applicantId = this.applicants[index].id;
      // console.log(applicantId);
      this.index = index;
      this.applicantJd = this.currentApplicantJd;
      this.$emit('changeIndex', index);
      //   this.isFavorited = this.applicants[index].isFavorite;
      //   this.isInterviewed = this.applicants[index].isInterview;
    },
    previous() {
      const index = this.index - 1;
      if (index === -1 && this.currentPage !== 1) {
        this.setPage({
          page: this.currentPage - 1,
          FirstProfileModalOpen: false,
          LastProfileModalOpen: true,
        });
      }
      if (this.applicants[index] !== undefined) {
        this.changeApplicant(index);
      }
      this.findMessageByJobseeker();
      this.showReplyForm = false;
      this.selectedMessageId = false;
    },
    next() {
      const index = this.index + 1;
      if (index * this.currentPage === this.applicantsCount.to) {
        this.setPage({
          page: this.currentPage + 1,
          FirstProfileModalOpen: true,
          LastProfileModalOpen: false,
        });
      } else if (this.applicants[index] !== undefined) {
        this.changeApplicant(index);
      }
      this.findMessageByJobseeker();
      // this.showReplyForm = false;
      this.selectedMessageId = false;
    },
  },
  mounted() {
    this.changeBodyBackground();
    // if (this.currentUser && !this.hasIndividualContactAuthority) {
    //   // this.$router.push('/applicant');
    // }
  },
  watch: {
    hasIndividualContactAuthority(newValue, oldValue) {
      if (!newValue) {
        // Navigate to a certain route when hasIndividualContactAuthority is false
        this.$router.push('/applicant');
      }
    },
    showIndividualContact(value) {
      this.showIndividualContact = value;
    },
  },
  async created() {
    await this.loadApplicantData();
  },
  beforeDestroy() {
    this.selectedMessageId = false;
    this.$emit('cancel');
  },
};
</script>

<style scoped>
.message-button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.message-button {
  background: #036ac9;
  border-radius: 30px;
  width: 200px;
  height: 61px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

.message-button:hover {
  background: #025a9e;
}
.message-detail-container {
  margin-top: 10px;
  padding: 8px;
  background-color: #fff;
}
.detail {
  text-align: left !important;
  margin-left: 5px;
  word-wrap: break-word;
  max-width: 200px;
  white-space: pre-line;
}
td {
  border: 2px solid #e6e6e6;
  background-color: #fff;
  text-align: left;
  padding: 5px;
  font-size: 14px;
  width: 300px;
  background-color: #e6e6e6;
  color: #617776;
}
:deep(.modal-footer) {
  justify-content: space-between;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
}

:deep(.modal-xl) {
  max-width: 90vw !important;
}

:deep(.modal-body) {
  padding: 0px !important;
  overflow: hidden;
}

:deep(.modal-content) {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

:deep(.modal-dialog) {
  height: 100%;
  margin: 1.75rem auto;
}

.btn-cancel {
  border-color: #3c3c3c;
  color: #3c3c3c;
  border-radius: 4px;
}

th {
  text-align: center;
}

.profile-block {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.new-submit-button {
  margin-left: 180px;
}

.contact-reply-btn {
  min-width: 115px;
  width: 115px;
  height: 33px;
  padding: 0px;
  font-size: 14px !important;
}

.openForm {
  min-width: 115px;
  width: 115px;
  height: 33px;
  padding: 0px;
  font-size: 14px !important;
  background: #fff !important;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
  border-radius: 3px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.message-label {
  color: #617776;
  width: 80px;
  min-width: 60px;
  max-width: 120px;
  white-space: nowrap;
  text-align: left;
  background-color: #e6e6e6;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
}

.message-content {
  min-width: 500px;
  font-size: 14px;
  background-color: #e6e6e6;
  padding: 5px;
  white-space: pre-wrap;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
}

.toggle-details-button {
  text-align: center;
  cursor: pointer;
  background-color: #ebeff1;
}

.toggle-details-icon {
  color: #617776;
  font-size: 1.5rem;
  margin-top: 0.5rem;
}

.toggle-details-text {
  display: inline-block;
  position: relative;
  bottom: 5px;
  font-size: 14px;
  color: #617776;
}
</style>
